var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader__wrapper"},[_c('img',{staticClass:"loader",attrs:{"alt":'trwa wczytywanie',"src":'//static.r.pl/rpl-cdn/images/biura/wypoczynek.gif'}})])}
var staticRenderFns = []

export { render, staticRenderFns }